// extracted by mini-css-extract-plugin
export default {"label-container":"FormLabel_label-container__vN8Fa","label":"FormLabel_label__6rV8u","optional":"FormLabel_optional__VK3PM"};